import dayjs from 'dayjs';

export type PastWinnersPeriod = {
  value: `${number}.${number}`;
  label: string;
};

/**
 * Returns
 * @param date any dayjs compatible date
 * @default
 * today
 *
 * @returns a period object with a value and a label.
 * @example
 *  input: dayjs('2021-01-01')
 *  output: { value: '01.21', label: 'Jan 2021'}
 */
export function formatPeriod(date = dayjs()) {
  const dateObj = dayjs(date);
  const month = (dateObj.month() + 1).toString().padStart(2, '0');
  const year = dateObj.year() % 100;
  return {
    value: `${month}.${year}` as PastWinnersPeriod['value'],
    label: dateObj.format('MMM YYYY'),
  };
}

/**
 * Returns an array of periods for the past months going
 * the specified amount of months back from the current month.
 *
 * @param numberOfMonths the number of months to go back from the current month
 * @default 6
 *
 * @returns an array of periods for the past months
 */
export function getPeriodsForThePastMonths(numberOfMonths = 6) {
  const periods: PastWinnersPeriod[] = [];
  for (let i = 0; i < numberOfMonths; i++) {
    const period = formatPeriod(dayjs().subtract(i, 'month'));
    periods.push(period);
  }
  return periods;
}
